import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWikivoyageComponent } from './simple-icons-wikivoyage.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWikivoyageComponent ],
    exports:      [ SimpleIconsWikivoyageComponent ],
    bootstrap:    []
})
export class SimpleIconsWikivoyageModule {}
